// types
import { Benefit, GalleryItem, Vacancy, Feature } from './types';

// images
import img1 from 'assets/images/photos/3.jpg';
import img2 from 'assets/images/photos/4.jpg';
import img3 from 'assets/images/photos/5.jpg';
import img4 from 'assets/images/photos/10.jpg';

const benefits: Benefit[] = [
    {
        icon: 'compass',
        title: 'Relocation Support',
        description: "We'll help to move and get settled and handle the visa process for you",
    },
    {
        icon: 'server',
        title: 'Technology',
        description: 'A special training to get start with our technical stack by professionals',
    },
    {
        icon: 'dollar-sign',
        title: 'Growth budget',
        description: 'A specific budget for your professionals growth which you spend on throughout the year',
    },
    {
        icon: 'users',
        title: 'Team activities & retreats',
        description: "Many team building activities and retreat every quarter, so you don't get bored",
    },
    {
        icon: 'map-pin',
        title: 'Work from anywhere',
        description: 'Work from anywhere you like. We offer remote working to all the employees',
    },
    {
        icon: 'coffee',
        title: 'Work/life balance',
        description: 'Flexible work hours gives you complete balance with your personal and professional life.',
    },
];



const features: Feature[] = [
    {
        icon: 'bar-chart-2',
        title: '🧠 Intelligent Dashboards',
        description: 'Personalized dashboards for sales, finance, and individual performance tracking. Get real-time insights with customizable widgets and KPI monitoring to make data-driven decisions quickly.',
    },
    {
        icon: 'users',
        title: '👥 Customer & Contact Management',
        description: 'Complete 360° view of accounts and contacts with relationship tracking. Store detailed customer information, communication history, and interaction logs all in one place for better customer relationships.',
    },
    {
        icon: 'trending-up',
        title: '📈 Sales Pipeline & Quotation',
        description: 'Track leads, deal stages, and generate quotes with ease. Monitor deal progress through every stage, forecast revenue accurately, and close deals faster with automated workflows.',
    },
    {
        icon: 'mail',
        title: '📣 Marketing Automation',
        description: 'Run email/SMS campaigns and capture leads via smart forms. Nurture leads automatically with targeted campaigns, track engagement metrics, and integrate seamlessly with your sales pipeline.',
    },
    {
        icon: 'folder',
        title: '📂 Project & Time Management',
        description: 'Assign, monitor projects and log hours for accurate billing. Track project progress, manage resources efficiently, and ensure timely delivery with milestone tracking and workload visualization.',
    },
    {
        icon: 'file-text',
        title: '📊 Comprehensive Reports',
        description: 'Access detailed analytics on leads, sales, and finances. Generate custom reports, set up automated reporting schedules, and export data in multiple formats for deeper analysis and presentations.',
    },
    {
        icon: 'dollar-sign',
        title: '💰 Finance Module',
        description: 'Manage orders, invoices, expenses, and payment tracking. Automate billing cycles, track payment status, manage receivables and payables, with full audit trails for financial compliance.',
    },
    {
        icon: 'help-circle',
        title: '🛠️ Customer Support',
        description: 'Resolve issues through ticketing system with SLA monitoring. Prioritize tickets by urgency, track resolution times, and maintain customer satisfaction with knowledge base integration and automated escalations.',
    },
    {
        icon: 'check-circle',
        title: '📋 Task Management',
        description: 'Assign tasks and monitor completion across teams. Set deadlines, track progress, prioritize work items, and improve team productivity with clear visibility into who is working on what.',
    },
    {
        icon: 'settings',
        title: '⚙️ Advanced Settings & Customization',
        description: 'Configure users, roles, system settings, and dropdowns. Customize workflows, fields, and business rules to match your unique process without any coding required.',
    },
    {
        icon: 'shield',
        title: '🔒 Security & Permissions',
        description: 'Role-based access control and data security features. Define granular permissions, encrypt sensitive data, maintain audit logs, and comply with industry security standards.',
    },
    {
        icon: 'truck',
        title: '🏢 Vendor Management',
        description: 'Manage vendor relationships, performance tracking, and supplier information. Maintain vendor scorecards, track delivery performance, manage contracts, and optimize procurement costs.',
    },
    {
        icon: 'shopping-cart',
        title: '📦 Purchase Order Management',
        description: 'Create, track, and manage purchase orders with approval workflows. Automate PO creation from requisitions, track order status, manage receipts, and reconcile invoices seamlessly.',
    },
    {
        icon: 'database',
        title: '📥 Data Import & Export',
        description: 'Bulk data operations with seamless import/export capabilities. Import customer data, export reports, sync with external systems, and migrate data with minimal downtime.',
    },
];


const gallery: GalleryItem[] = [
    {
        id: 3,
        image: {
            src: img1,
            caption: 'Office Desks',
        },
    },
    {
        id: 4,
        image: {
            src: img2,
            caption: 'Meeting Room view',
        },
    },
    {
        id: 5,
        image: {
            src: img4,
            caption: 'Outside view',
        },
    },
    {
        id: 6,
        image: {
            src: img3,
            caption: 'A common seating area',
        },
    },
];

const vacancies: Vacancy[] = [
    {
        category: 'Engineering',
        jobs: [
            {
                designation: 'Techical Support Engineer',
                type: 'Remote',
            },
            {
                designation: 'Senior Software Engineer (Frontend)',
                type: 'Remote',
            },
            {
                designation: 'Senior Software Engineer (Backend)',
                type: 'Remote',
            },
            {
                designation: 'Engineering Manager',
                type: 'Remote',
            },
        ],
    },
    {
        category: 'Marketing',
        jobs: [
            {
                designation: 'Junior copywriter/editor',
                type: 'Remote',
            },
        ],
    },
];

export { benefits, gallery, vacancies, features };
